<script lang="ts" setup>
const { alert, setAlert } = useStore();
const handleClose = () => {
    setAlert({
        isShow: false,
        type: '',
        data: {
            message: '',
            type: 'success'
        }
    })
}
const handleMessage = () => {
    navigateTo('/mypage/message');
    handleClose();
}

const handleHistory = () => {
    if (alert.value.tab == 'minigame') {
        navigateTo('/mypage/history?tab=minigame');
    } else {
        navigateTo('/mypage/history');
    }
    
    handleClose();
}
</script>
<template>
    <div class="alert">
        <el-dialog
            :model-value="alert.isShow"
            width="300"
            align-center
            :show-close="false"
            @update:model-value="handleClose"
            :close-on-click-modal="false"
            >
            <template v-if="alert.data.type == 'success'">
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"></path><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path></svg>
            </template>
            <template v-else>
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path><path d="M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"></path></svg>
            </template>
            <p class="alarm-content">{{ alert.data.message }}</p>
            <template v-if="alert.type == 'unread-message'">
                <button class="alarm-btn" @click="handleMessage">메세지 확인</button>                
            </template>
            <template v-else-if="alert.type == 'bet-completed'">
                <button class="alarm-btn mb-2" @click="handleClose">확인</button>
                <button class="alarm-btn" @click="handleHistory">베팅내역</button>
            </template>
            <template v-else>
                <button class="alarm-btn" @click="handleClose">확인</button>
            </template>
        </el-dialog>
    </div>
</template>